export const FLASH_BUTTON_STATUS_FOR = {
    FLASH_ON: "FLASH_ON",
    FLASH_OFF: "FLASH_OFF",
};

export const FLASH_STATE = {
    ON: 1,
    OFF: 2,
    ENABLED: 3,
    DISABLED: 4,
};

export const FLASH_REASON_ID = {
    FRONT_CAMERA_ON: 1 /* used for mobile */,
    APP_IS_IN_BACKGROUND: 2 /* used for mobile */,
    ENABLE: 3,
};
export const HANDLE_FLASH_ON_OR_OFF = "HANDLE_FLASH_ON_OR_OFF";
